import React from 'react';
export default class RefereeForm extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            selected: {
                name: "",
                id: '',
                created: '',
                type_tournament: '',
                type_tournament_name: ''
            }
        };
    }

    componentWillMount(){
        let st = {...this.props.selected}
        if(localStorage.getItem("rol")=="admin")
            st.tournament = 'futrapido'
        else
            st.tournament = localStorage.getItem("rol")
        this.setState({selected: st});
    }

    handleKeyPress(e){
        if (e.key === 'Enter') {
            this.props.save(this.state.selected)
        }
    }

    render(){
        return(
            <div id="form">
                <input className="input form_input" autoFocus type="text" placeholder="Árbitro" value={this.state.selected.name} onKeyPress={(e) => this.handleKeyPress(e)} onChange={(e) => {
                    let state = {...this.state};
                    state.selected.name = e.currentTarget.value;
                    this.setState(state);
                }} />
                <div className="field-body">
                    <select
                        onKeyPress={(e) => this.handleKeyPress(e)}
                        className="input"
                        onChange={(e) => {
                            let state = {...this.state};
                            state.selected.tournament = e.currentTarget.value;
                            state.selected.type_tournament_name = "Fútbol rápido";
                        }}
                    >
                        {(localStorage.getItem("rol")=="futrapido" || localStorage.getItem("rol")=="admin") && 
                            <option key={1} defaultValue="futrapido" value="futrapido" selected={"futrapido"==this.state.selected.tournament ? "selected" :"" }>
                                Fútbol rápido
                            </option>
                        }
                        {(localStorage.getItem("rol")=="fut7" || localStorage.getItem("rol")=="admin") && 
                            <option key={2} defaultValue="fut7" value="fut7" selected={"fut7"==this.state.selected.tournament ? "selected" :"" }>
                                Fútbol 7
                            </option>
                        }
                    </select>
                </div>
                <div className="columns has-text-right buttons-modal">
                    <div className="column">
                        <button className="button is-success" id="save" onClick={() => this.props.save(this.state.selected)}>Guardar</button>
                        <button className="button" onClick={() => this.props.cancel()}>Cancelar</button>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/referee/form.js